<div id="generate-glossary" class="m-3">

    <h1>Generar glosario</h1>

    <p>Con esta herramienta puedes generar un glosario de palabras para el curso. Primero, selecciona una unidad para la cual se generará el glosario. Después, usa el buscador para buscar palabras en la base de datos de Wikipedia, y una vez que la lista de palabras sea generada, puedes ver su definición haciendo clic en la palabra. Si quieres añadirlas al glosario, selecciónalas con la cajita de selección y pulsa "Guardar glosario".</p>

    <label for="course-units" class="d-block mt-3">
        <p class="fw-bold">Unidad:</p>
        <select name="course-units" id="course-units" [(ngModel)]="selectedUnit">
            <option disabled selected value="-1">Seleccione una unidad...</option>
            <option *ngFor="let unit of courseUnits" value="{{ unit.id }}">
                {{ unit.name }}
            </option>
        </select>
    </label>

    <label for="reset" class="d-block mt-3">
        <span class="fw-bold">¿Borrar entradas existentes?</span>
        <input type="checkbox" name="reset" id="reset" class="mx-3 my-0" [(ngModel)]="reset">
    </label>

    <label for="glossary-search-value" class="d-block mt-3">
        <p class="fw-bold">Buscar en Wikipedia:</p>
        <input class="form-control" type="text" id="glossary-search-value" name="glossary-search-value" class="d-inline-block" [(ngModel)]="searchTerm" (keydown.enter)="glossarySearch()" />
        <button id="glossary-search" class="btn btn-primary ms-3" (click)="glossarySearch()" [attr.disabled]="searching ? 'disabled' : null">
            <i class="fa fa-search"></i>
            <span>Buscar</span>
        </button>
        <div id="search-spinner" class="mx-0 my-3" *ngIf="searching">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Buscando...</span>
        </div>
    </label>

    <div id="glossary-search-results" class="mt-3" *ngIf="!searching && wordList.length > 0">
        <p class="fw-bold">Términos encontrados:</p>
        <div class="card" *ngFor="let word of wordList; let w = index;">
            <!-- <span class="link" (click)="showDefinition(word)">Ver definición</span> -->
            <div class="card-header">
                <p class="fw-bold">Palabra #{{ w + 1 }}</p>
                <input type="text" [(ngModel)]="word.word" size="50">
            </div>
            <div class="card-body">
                <p class="fw-bold">Definición:</p>
                <textarea cols="100" rows="15" [(ngModel)]="word.definition"></textarea>
            </div>
            <div class="card-footer">
                <label class="d-block mt-3">
                    <input type="checkbox" class="mx-3 my-0" [attr.checked]="wordIndexInGlossary(word) !== -1 ? true : null" (click)="glossaryList(word)">
                    <span class="fw-bold">Seleccionar para añadir</span>
                </label>
            </div>
        </div>
    </div>

    <!--
    <div id="selected-words" *ngIf="selectedWords.length > 0 && !searching">
        <b>Términos seleccionados:</b>
        <ul id="selected-words-list">
            <li *ngFor="let word of selectedWords">
                <span>{{ word.word }}</span>
            </li>
        </ul>
        <button id="selected-words-clear" class="btn btn-danger" (click)="clear()">
            <i class="fa fa-trash-alt"></i>
            <span>Limpiar</span>
        </button>
    </div>
    -->

    <div id="generate-glossary-status" class="form-group m-3">
        <div id="glossary-spinner" *ngIf="glossaryLoading">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Procesando, espere por favor...</span>
        </div>
        <div id="glossary-error" class="text-danger" *ngIf="glossaryError">
            <i class="fa fa-times"></i>
            <span>Hubo un error, no se generó el glosario. Por favor, inténtelo de nuevo.</span>
        </div>
        <div id="glossary-success" class="text-success" *ngIf="glossarySuccess">
            <i class="fa fa-check"></i>
            <span>Se ha generado el glosario correctamente. Ahora será redireccionado, espere un momento...</span>
        </div>
    </div>

    <div id="generate-glossary-buttons" class="form-group">
        <button class="btn btn-primary me-3" routerLink="/course/{{ courseID }}" routerLinkActive="active">
            <i class="fa fa-arrow-left"></i>
            <span>Volver</span>
        </button>
        <button class="btn btn-success me-3" (click)="generateGlossary()" [attr.disabled]="selectedUnit > 0 && selectedWords.length > 0 && !searching ? null : 'disabled'">
            <i class="fas fa-list"></i>
            <span>Generar glosario</span>
        </button>
    </div>
    
</div>
